export default __webpack_public_path__ + "static/media/scouts-in-a-row.4acbd56b.jpg";